var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PctileChart',_vm._b({attrs:{"loading":_vm.percentiles.loading,"data":_vm.percentiles.data}},'PctileChart',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }